import { memo, useState } from "react";

import { Popover } from "antd";

import { ToolbarButton } from "components/base";
import CollapseVerticalIcon from "components/icons/CollapseVertical";
import { useChartSettings } from "components/multiphase-chart/context";

import Normalize from "./Normalize";

const NormalizeToggle = () => {
  const [chartSettings] = useChartSettings();
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      arrowPointAtCenter
      content={<Normalize />}
      onOpenChange={(v) => setVisible(v)}
      open={visible}
      overlayClassName="normalize-popover"
      placement="bottomRight"
      trigger="click">
      <ToolbarButton
        testId="multiphasechart-toolbar-normalize-toggle"
        icon={<CollapseVerticalIcon />}
        isMenuButton={true}
        overflowLabel="Normalize"
        tooltipText="Normalize"
        active={chartSettings.settings?.useNormalizeBy}
        isGlobalSetting={true}
      />
    </Popover>
  );
};

export default memo(NormalizeToggle);
